import React, { MouseEvent } from 'react';
import classNames from 'classnames/bind';
import { TFunction } from 'next-i18next';

import Icon from 'koba/components/Icon';
import Modal from 'koba/components/Modal';
import { ButtonWithIconOnly } from 'koba/components/Button';

import styles from './ActionModal.module.scss';

const cx = classNames.bind(styles);

interface ActionModalProps {
  children?: React.ReactNode;
  closeModal: (e: MouseEvent<HTMLButtonElement>) => void;
  isOpen: boolean;
  t: TFunction;
  dataQA?: string;
}

const ActionModal: React.FC<ActionModalProps> = ({
  children = null,
  isOpen,
  closeModal,
  t,
  dataQA,
}) => (
  <Modal closeModal={closeModal} dataQA={dataQA} isOpen={isOpen} isFullWidth>
    <div className={cx('action-modal__body')}>
      <div className={cx('action-modal__list')}>{children}</div>
      <ButtonWithIconOnly
        appearance="knockout"
        aria-label={t('Close modal')}
        className={cx('action-modal__close-button')}
        onClick={closeModal}
      >
        <Icon name="x-dismiss" />
      </ButtonWithIconOnly>
    </div>
  </Modal>
);

export default ActionModal;
